export const MAX_GENRES = 3;

export function genreNamesForIds(genres, ids) {
  if (!ids || !ids.length) return [];
  const byId = {};
  (genres || []).forEach((g) => { byId[g.id] = g.name; });
  return ids.map((id) => byId[id]).filter(Boolean);
}
export const SOCIAL_PLATFORMS = [
  { id: "website",    label: "אתר רשמי",    kind: "url",    group: "web" },
  { id: "store",      label: "חנות",         kind: "url",    group: "web" },
  { id: "wikipedia",  label: "ויקיפדיה",     kind: "url",    group: "web" },
  { id: "spotify",    label: "Spotify",      kind: "url",    group: "stream" },
  { id: "apple",      label: "Apple Music",  kind: "url",    group: "stream" },
  { id: "youtube",    label: "YouTube",      kind: "url",    group: "stream" },
  { id: "deezer",     label: "Deezer",       kind: "url",    group: "stream" },
  { id: "amazon",     label: "Amazon Music", kind: "url",    group: "stream" },
  { id: "soundcloud", label: "SoundCloud",   kind: "url",    group: "stream" },
  { id: "bandcamp",   label: "Bandcamp",     kind: "url",    group: "stream" },
  { id: "joker",      label: "ג׳וקר",        kind: "url",    group: "stream" },
  { id: "headstart",  label: "Headstart",    kind: "url",    group: "stream" },
  { id: "instagram",  label: "Instagram",    kind: "handle", group: "social" },
  { id: "facebook",   label: "Facebook",     kind: "url",    group: "social" },
  { id: "tiktok",     label: "TikTok",       kind: "handle", group: "social" },
  { id: "twitter",    label: "X / Twitter",  kind: "handle", group: "social" },
  { id: "snapchat",   label: "Snapchat",     kind: "handle", group: "social" },
];

export const SOCIAL_GROUPS = [
  { id: "stream", label: "סטרימינג והפצה" },
  { id: "social", label: "רשתות חברתיות" },
  { id: "web",    label: "אתרים וחנות" },
];

export const CONTACT_TYPES = [
  { id: "pr",         label: "יחסי ציבור", desc: "איש קשר מול תקשורת ומדיה", icon: "megaphone" },
  { id: "management", label: "ניהול",       desc: "מנהל/ת אישי או חברת ניהול", icon: "briefcase" },
  { id: "booking",    label: "בוקינג",      desc: "הזמנת הופעות ואירועים",     icon: "calendar" },
];

export const STEPS = [
  { id: "identity", title: "פרטי האומן",   sub: "מי אתם?",          icon: "user" },
  { id: "genres",   title: "סגנון מוזיקלי", sub: "מה אתם נוגנים?",    icon: "music" },
  { id: "socials",  title: "קישורים",       sub: "איפה למצוא אתכם",   icon: "link" },
  { id: "contacts", title: "אנשי קשר",      sub: "מי מטפל בכם",       icon: "briefcase" },
];

export function freshFormState() {
  return {
    artistName: "",
    email: "",
    phone: "",
    password: "",
    photo: null,
    genres: [],
    socials: {},
    contacts: {
      pr:         { enabled: false, name: "", phone: "", email: "" },
      management: { enabled: false, name: "", phone: "", email: "" },
      booking:    { enabled: false, name: "", phone: "", email: "" },
    },
  };
}

export function validateStep(idx, data) {
  const errors = {};
  if (idx === 0) {
    if (!data.artistName.trim()) errors.artistName = "חסר שם אומן";
    if (!data.email.trim()) errors.email = "חסרה כתובת מייל";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errors.email = "כתובת מייל לא תקינה";
    if (!data.phone.trim()) errors.phone = "חסר מספר פלאפון";
    else if ((data.phone.replace(/\D/g, '')).length < 9) errors.phone = "מספר פלאפון לא תקין";
    if (!data.password) errors.password = "חסרה סיסמה";
    else if (data.password.length < 8) errors.password = "לפחות 8 תווים";
  }
  if (idx === 1) {
    if (!data.genres.length) errors.genres = "בחרו לפחות סגנון אחד";
  }
  if (idx === 3) {
    const contactErrs = {};
    for (const ct of CONTACT_TYPES) {
      const c = data.contacts[ct.id];
      if (c && c.enabled) {
        const e = {};
        if (!c.name.trim()) e.name = "חסר שם";
        if (!c.phone.trim() && !c.email.trim()) {
          e.phone = "חובה טלפון או מייל";
          e.email = "חובה טלפון או מייל";
        } else if (c.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email)) {
          e.email = "מייל לא תקין";
        }
        if (Object.keys(e).length) contactErrs[ct.id] = e;
      }
    }
    if (Object.keys(contactErrs).length) errors.contacts = contactErrs;
  }
  return errors;
}

export function buildArtistPayload(data) {
  const socials = {};
  Object.keys(data.socials || {}).forEach((key) => {
    const val = (data.socials[key] || '').trim();
    if (val) socials[key] = val;
  });

  const contacts = {};
  for (const type of ['pr', 'management', 'booking']) {
    const c = data.contacts[type];
    if (c && c.enabled) {
      contacts[type] = {
        enabled: true,
        name: (c.name || '').trim(),
        phone: (c.phone || '').trim(),
        email: (c.email || '').trim(),
      };
    }
  }

  return {
    name: (data.artistName || '').trim(),
    username: (data.email || '').trim(),
    password: data.password || '',
    phone: (data.phone || '').trim(),
    genres: data.genres || [],
    socials,
    contacts,
  };
}

export function buildSignupFormData(data) {
  const formData = new FormData();
  formData.append('payload', JSON.stringify(buildArtistPayload(data)));
  if (data.photo && data.photo.file) {
    formData.append('photo', data.photo.file, data.photo.name);
  }
  return formData;
}
